import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarker2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"marker-2, highlight"} maskId="square-filled-radius-0-stroke-1-IconMarker2"><path d="M17.6201 9.01465L17.7549 9.04883L21.2061 12.5L11.499 22.207L8.04785 18.7559L8.01367 18.6211L6.94531 14.3467L13.3457 7.94629L17.6201 9.01465Z" fill="currentColor"/><path d="M12.4561 7.75L6.74902 13.457L4.64551 11.3535L4.46094 11.1699L4.50684 10.9131L6.17383 1.46777L12.4561 7.75Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMarker2;
